import { yupResolver } from '@hookform/resolvers/yup';
import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { Pressable, View } from 'react-native';
import { Checkbox, Footer, Input, Text } from '~/components';

import * as yup from 'yup';
import useAppNavigation from '~/hooks/useAppNavigation';
import { useCreateAccountForm } from '~/stores';
import type { CreateAccuntStepsProps } from '../..';

interface StepFormData {
  password: string;
  confirmPassword: string;
}

export const schema = yup
  .object()
  .shape({
    password: yup
      .string()
      .min(6, 'A senha deve ter pelo menos 6 dígitos.')
      .required('A senha é obrigatória.'),
    confirmPassword: yup
      .string()
      .required('Por favor, informe a senha novamente')
      .oneOf([yup.ref('password')], 'As senhas não coincidem'),
  })
  .required();

const Password: React.FC<CreateAccuntStepsProps> = ({ onContinue }) => {
  const { navigate } = useAppNavigation();
  const { setPassword } = useCreateAccountForm();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<StepFormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    (data: StepFormData) => {
      setPassword(data.password);
      onContinue?.();
    },
    [onContinue, setPassword]
  );

  return (
    <View className="justify-between lg:w-[450px]">
      <Text className="text-[22px] text-center text-gray-700 mt-6 mb-14">
        Vamos definir sua{' '}
        <Text className="text-primary-600 font-medium">Senha</Text>?
      </Text>

      <View className="mb-10">
        <Input
          control={control}
          name="password"
          label="Senha"
          placeholder="Senha"
          error={errors.password?.message}
          isPassword
        />

        <Input
          control={control}
          name="confirmPassword"
          label="Confirme a senha"
          placeholder="Confirme a senha"
          error={errors.confirmPassword?.message}
          isPassword
        />

        <Checkbox control={control} name="acceptTermsAndConditions">
          <Pressable
            onPress={() => navigate('MarisaServicos_TermsAndConditions')}
          >
            <Text className="text-xs text-gray-600 lg:w-[450px]">
              Li, compreendi e concordo com as{' '}
              <Text className="text-primary-600">condições gerais</Text>,
              inclusive com a{' '}
              <Text className="text-primary-600">
                relação à proteção de dados pessoais, finalidades
              </Text>{' '}
              e{' '}
              <Text className="text-primary-600">
                hipóteses de tratamento de dados
              </Text>
            </Text>
          </Pressable>
        </Checkbox>
      </View>

      <Footer
        noPadding
        onSubmit={handleSubmit(onSubmit)}
        buttonLabel="Prontinho!"
      />
    </View>
  );
};

export default Password;
